import React from "react";
import { Table } from "antd";

const TimetableReadonlyTable = ({ columns, rows }) => (
    <Table
        rowKey="id"
        className="schedule-draft-timetable-table"
        columns={columns}
        dataSource={rows}
        pagination={false}
        scroll={{ x: 1380 }}
        size="small"
        rowClassName={(record) => (record?._hasRotationGapAfter ? "schedule-draft-timetable-table-row-gap-after" : undefined)}
    />
);

export default TimetableReadonlyTable;
